/** @jsx jsx */
import React, { useEffect } from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';
import { useDrop, DropTargetMonitor } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

type FileDnDBoxProps = {
  onDrop: (props: FileDnDBoxProps, monitor: DropTargetMonitor) => void
}

const FileDnDBox: React.FC<FileDnDBoxProps & {
  setActive: (isActive: boolean) => void
  fullWidth?: boolean,
  customStyle?: SerializedStyles
}> = ({
  onDrop, setActive, children, fullWidth, customStyle
}) => {
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: [NativeTypes.FILE],
    drop(item, monitor) {
      if (onDrop) {
        onDrop({ onDrop }, monitor);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  useEffect(() => {
    setActive(canDrop && isOver);
  }, [canDrop, isOver, setActive]);
  return (
    <div ref={drop} css={css([fullWidth ? { width: '100%' } : {}, customStyle])}>
      {children}
    </div>
  );
};

export default FileDnDBox;
